import { Link } from "react-router-dom";
import useProfile from "../../Hooks/useProfile";
import useSetting from "../../Hooks/useSetting";
import NewsLetter from "./NewsLetter";
// import Support from "../../image/support.svg";
import { Row, Col } from "react-bootstrap";
import Location from "../../image/location.svg";
import MobileIcon from "../../image/mobile-icon.svg";
import EmailIcon from "../../image/email-icon.svg";
import WorkingHours from "../../image/working-hours.svg";
import WhatsappIcon from "../../image/whatsapp.svg";

import Logo from "../../image/footer-logo.png";
// import Logo from "../../image/footer-logo.jpeg";
import SafeLogo from "../../image/safe.svg";
import Natural from "../../image/natural.svg";
import Effactive from "../../image/effactive.svg";
import GmpCertified from "../../image/gmp-certified.svg";
import IsoCertified from "../../image/iso-certified.svg";
import MakeInIndia from "../../image/make-in-india.png";
import GooglePlay from '../../image/google-play.svg';
import AppStore from '../../image/app-store.svg';

const public_path = process.env.REACT_APP_PUBLIC_URL;

const Footer = () => {
  const { id } = useProfile();
  const { copyright, topCats, address } = useSetting();
  return (
    <>
      <footer>
        <div className="container">
          <div className="row mb-4">
            <div className="col text-md-center text-left">
              <a href="/" className="footer-logo-top">
                <img src={Logo} alt="SBL Logo" width="100" height="132" title="SBL Logo" loading="lazy" decoding="async"/>
              </a>
            </div>

            <div className="col-9 right-content">
              <div className="footer-logo-list">
                <ul className="list-inline">
                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={Natural}
                      alt="Natural Logo"
                      title="Natural Logo"
                      width="87"
                      height="87"
                    />
                    {/* </a> */}
                  </li>
                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={SafeLogo}
                      alt="Safe Logo"
                      title="Safe Logo"
                      width="100"
                      height="80"
                    />

                    {/* </a> */}
                  </li>

                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={Effactive}
                      alt="Effactive"
                      title="Effactive"
                      width="80"
                      height="90"
                    />

                    {/* </a> */}
                  </li>

                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={MakeInIndia}
                      alt="Make In India"
                      title="Make In India"
                      width="135"
                      height="80"
                    />
                    {/* </a> */}
                  </li>

                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={GmpCertified}
                      alt="GMP Certified"
                      title="GMP Certified"
                      width="87"
                      height="87"
                    />
                    {/* </a> */}
                  </li>

                  <li className="list-inline-item">
                    {/* <a href="#"> */}
                    <img
                      src={IsoCertified}
                      alt="ISO Certified"
                      title="ISO Certified"
                      width="87"
                      height="87"
                    />
                    {/* </a> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="support-box">
                <ul className="list-unstyled mb-0">
                  <li>
                    <p className="mb-0">Support</p>
                  </li>
                  <li>
                    <span>
                      <img
                        src={Location}
                        alt="Location"
                        title="Location"
                        width="25"
                        height="28"
                      />
                    </span>{" "}
                    <span>{address}</span>
                  </li>

                  <li>
                    <span>
                      <img
                        src={MobileIcon}
                        alt="Phone"
                        title="Phone"
                        width="20"
                        height="22"
                      />
                    </span>{" "}
                    <span>
                      <a
                        className="text-decoration-none text-white"
                        href="tel:+91-11-43731000"
                      >
                        +91-11-43731000
                      </a>
                      ,{" "}
                      <a
                        className="text-decoration-none text-white"
                        href="tel:+91-11-43731025"
                      >
                        43731025
                      </a>
                      ,{" "}
                      <a
                        className="text-decoration-none text-white"
                        href="tel:+91-11-35301970"
                      >
                        35301970
                      </a>
                    </span>
                  </li>
                  <li>
                    <span>
                      <img
                        src={WhatsappIcon}
                        alt="WhatsApp"
                        title="WhatsApp"
                        width="20"
                        height="22"
                      />
                    </span>{" "}
                    <span>
                      <a
                        className="text-decoration-none text-white"
                        href={`https://wa.me/+918851654420`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        +91-8851654420
                      </a>
                    </span>
                  </li>
                  <li>
                    <span>
                      <img
                        src={EmailIcon}
                        alt="Email"
                        title="Email" 
                        width="20"
                        height="20"
                      />
                    </span>{" "}
                    <span>
                      <a
                        className="text-decoration-none text-white"
                        href="mailto:care@sblglobal.in"
                      >
                        care@sblglobal.in
                      </a>
                      ,<br /> E-commerce:{" "}
                      <a
                        className="text-decoration-none text-white"
                        href="mailto:onlinecare@sblglobal.in"
                      >
                        onlinecare@sblglobal.in
                      </a>
                      ,<br /> Export Support:{" "}
                      <a
                        className="text-decoration-none text-white"
                        href="mailto:exportcare@sblglobal.in"
                      >
                        exportcare@sblglobal.in
                      </a>
                    </span>
                  </li>
                  <li>
                    <span>
                      <img
                        src={WorkingHours}
                        alt="Working Hours"
                        title="Working Hours"
                        width="20"
                        height="20"
                      />
                    </span>{" "}
                    <span>
                      9:00 am – 5:30 pm from Mon. to Sat.
                      <br />
                      (Except Public Holidays)
                    </span>
                  </li>
                </ul>
              </div>

              <div className="google-play-button bg-white p-3 mt-4">
                <h5 className="text-black mb-2">Download the app now!</h5>

                <ul className="list-inline mb-0 d-flex">
                  <li className="list-inline-item">
                    <a href="https://play.google.com/store/apps/details?id=sblglobal.app" className='d-block' target="_blank" title="Download Android App">
                      <img
                        src={GooglePlay}
                        alt="Download Android App"
                        title="Download Android App"
                        className='img-fluid' width={170} height={30}
                      />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://apps.apple.com/in/app/sbl-homoeopathy/id6711352380" className='d-block' target="_blank" title="Download iOS App">
                      <img
                        src={AppStore}
                        alt="Download iOS App" width={170} height={30}
                        title="Download iOS App"
                        className='img-fluid'
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-8 d-grid footer-link-col">
              <div className="row g-0 justify-content-between">
                <div className="col-md-2">
                  <div className="footer-link">
                    <p>Useful Links</p>
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/career`}
                        >
                          Career
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/contact-us`}
                        >
                          Contact Us
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/dealer-locator`}
                        >
                          Dealer Locator
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/certificate-download`}
                        >
                          Certificate
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <p>Products</p>
                    <ul className="list-unstyled">
                      {topCats.map((item, i) => (
                        <li key={i}>
                          <Link
                            className="text-decoration-none text-white"
                            to={`${public_path}/products/${item?.slug}`}
                          >
                            {item?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <p>My Accounts</p>
                    <ul className="list-unstyled">
                      {id ? (
                        <>
                          <li>
                            <Link
                              className="text-decoration-none text-white"
                              to={`${public_path}/profile`}
                            >
                              Profile
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="text-decoration-none text-white"
                              to={`${public_path}/cart`}
                            >
                              Cart
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="text-decoration-none text-white"
                              to={`${public_path}/checkout`}
                            >
                              Checkout
                            </Link>
                          </li>
                        </>
                      ) : (
                        <li>
                          <Link
                            className="text-decoration-none text-white"
                            to={`${public_path}/login`}
                          >
                            Login
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <p className="fw-bold">Guide & Help</p>
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/faq-help`}
                        >
                          FAQs
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/blogs`}
                        >
                          Blogs
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/testimonial`}
                        >
                          Testimonial
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/health-coins-faq-help`}
                        >
                         Health Coins FAQs
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <p>Company Policy</p>
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/disclaimer`}
                        >
                          Disclaimer
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/privacy-policy`}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/returns-exchanges`}
                        >
                          Returns & Exchanges
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/delivery-information`}
                        >
                          Delivery Information
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/terms-conditions`}
                        >
                          Terms & Conditions
                        </Link>
                      </li>
                      {/* <li><Link className="text-decoration-none text-white" to={`${public_path}/news`}>News</Link></li> */}
                    </ul>
                  </div>
                </div>
              </div>

              {/* extra */}
              <div className="row g-0 justify-content-between my-4 border-top pt-4">
                <div className="col-md-2">
                  <div className="footer-link">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product`}
                        >
                          All Products
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/personal-care/baby-care`}
                        >
                          Baby Care Product
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/bio-chemic-bio-combinations/bio-chemics`}
                        >
                          Bio Chemics Product
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/bio-chemic-bio-combinations/bio-combination`}
                        >
                          Bio Combination Product
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product/kalmegh-drops-1678`}
                        >
                          Kalmegh Drops
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/dilutions-lm-potencies/dilutions`}
                        >
                          Dilutions
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/eye-ear-drop`}
                        >
                          Eye/Ear Drop
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/personal-care/hair-care`}
                        >
                          Hair Care
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/herbals`}
                        >
                          Herbals
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/personal-care/hygiene-care`}
                        >
                          Hygiene Care
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/liquid-specialities`}
                        >
                          Liquid Specialities
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/dilutions-lm-potencies/lm-potency-dilutions`}
                        >
                          LM Potency Dilutions
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/mother-tinctures`}
                        >
                          Mother Tinctures
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/homoeopathic/tablet-specialities`}
                        >
                          Tablet Specialities
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/ointments`}
                        >
                          Ointments
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/personal-care/oral-care`}
                        >
                          Oral Care
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/products/personal-care/skin-care`}
                        >
                          Skin Care
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="footer-link">
                    <ul className="list-unstyled">
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product/alfalfa-tonic-with-ginseng-1323-1668`}
                        >
                          Alfalfa Tonic with Ginseng
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product/montana-herbal-shampoo-combo`}
                        >
                          Montano Herbal Shampoo Combo
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product/montana-herbal-shampoo-conditioner-combo`}
                        >
                          Montana Herbal Shampoo Conditioner Combo
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="text-decoration-none text-white"
                          to={`${public_path}/product/prostonum-drops-1688`}
                        >
                          Prostonum Drops
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-8 col-md-8 mt-auto">
                  <p className="text-white foottextwhite">
                    {" "}
                    Get Updates & Stay Connected{" "}
                  </p>
                  <NewsLetter />
                </div>
                <div className="col-md-4 mt-auto download-button">
                  <Link
                    className="btn btn-success btn-lg"
                    to={`${public_path}/download`}
                  >
                    Download Catalogue
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Useful links in footer for SEO Purpose */}

          {/* <Row className="mt-4">
            <Col
              xs={12}
              md={12}
              className="text-center  pt-2 mb-3"
            >
              <h6 className="text-white">USEFUL LINKS</h6>
            </Col>
            <Col xs={6} md={3}>
              <ul className="list-unstyled">
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/products/hair-care`}
                  >
                    Hair Care
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-1307`}
                  >
                   Mother Tinctures
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-1895`}
                  >
                    Alfalfa Homeopathy Liquid Dilutions
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-malt-1667`}
                  >
                    General Weakness
                  </Link>
                </li>
        <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/sbl-stobal-cough-syrup-sugar-free-1703`}
                  >
                    Cough Syrup Sugar Free
                  </Link>
                </li>
        <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/kalmegh-syrup-1679`}
                  >
                    Kalmegh Syrup
                  </Link>
                </li>
        <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/liv-t-1680`}
                  >
                    Liv T Liver Tonic
                  </Link>
                </li>
              </ul>
            </Col>

            <Col xs={6} md={3}>
              <ul className="list-unstyled">
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-malt-1667`}
                  >
                   Alfalfa Malt for Weight Gain
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-tonic-paediatric-1666`}
                  >
                    Alfalfa Tonic Paediatric
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-tonic-with-ginseng-1323-1668`}
                  >
                    Ginseng Tonic
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/alfalfa-tonic-with-ginseng-1668`}
                  >
                    Alfalfa Tonic for Weight Gain
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/arnica-montana-1052`}
                  >
                    Arnica Montana
                  </Link>
                </li>

                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/phytolacca-berry-tablets-1734`}
                  >
                    Phytolacca Berry Tablets
                  </Link>
                </li>

                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/sbl-stobal-cough-syrup-1702`}
                  >
                    Stobal Cough Syrup
                  </Link>
                </li>

               
              </ul>
            </Col>
            <Col xs={6} md={3}>
              <ul className="list-unstyled">
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/bio-combination-no-21-21`}
                  >
                    Bio-Combination 21
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/calcarea-phosphorica-1746`}
                  >
                    Calc Phos Homeopathy
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/calcarea-phosphorica-2070`}
                  >
                   Calcarea Phosphorica
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/calcarea-phosphorica-6x-combo-25gm-each`}
                  >
                   Calcarea Phosphorica 6X
                  </Link>
                </li>

                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/montana-herbal-shampoo-34`}
                  >
                   Montana Herbal Shampoo
                  </Link>
                </li>

                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/montana-herbal-shampoo-combo`}
                  >
                   Shampoo For Hair Fall
                  </Link>
                </li>

                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/montana-herbal-shampoo-conditioner-35`}
                  >
                   Shampoo With Conditioner
                  </Link>
                </li>
              </ul>
            </Col>
            <Col xs={6} md={3}>
              <ul className="list-unstyled">
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/clearstone-drops-1673`}
                  >
                    Clear Stone Drops
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/damiagra-forte-drops-1674`}
                  >
                   Damiagra Forte Drops
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/dibonil-tablets-1721`}
                  >
                    Dibonil Tablets
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/homeocal-tablets-1729`}
                  >
                    Homeocal Tablets for Osteoporosis
                  </Link>
                </li>
                <li>
                  <Link
                  style={{fontSize:'15px',fontWeight:'500',marginBottom:'8px'}}
                    className="text-decoration-none text-white"
                    to={`${public_path}/product/sbl-drops-no-4-1695`}
                  >
                    Homoeopathic Medicine FOR Hypertension
                  </Link>
                </li>  
              </ul>
            </Col>
          </Row> */}
        </div>
        {/* <hr className="mt-2 mb-0 bg-white" /> */}
        <div className="copy-right-area">
          <div className="container">
            <div className="row small-text-white">
              <div className="col-12">
                <div className="copy-right-row">
                  <div>
                    <span>{copyright}</span>
                  </div>

                  {/* <div className="copy-right-content">
                    <p>Web Design &amp; Development by <a href="https://www.digitalxplode.com" target="_blank" rel="noreferrer">Digital Xplode</a> </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;

